/* eslint-disable react-hooks/exhaustive-deps */
import { message, Modal } from 'antd';
import { ConfigProvider as UserInfoProvider } from 'library/context';
import { observer } from 'mobx-react';
import { useEffect, useMemo } from 'react';
import { BrowserRouter as Router } from 'react-router-dom'; // 改回 BrowserRouter
import useStores from 'src/hooks/useStore';
import router from 'src/router';
import { headers, toLoigin } from 'src/utils/request';
import ConfigProvider from './components/ConfigProvider';
import Initialization from './components/Initialization';
import RenderRouter from './components/RenderRouter';

const BASE_PREFIX = process.env.REACT_APP_BASE_PREFIX;

function App() {
  const { commonStore } = useStores();
  const { baseInfo } = commonStore;

  useEffect(() => {
    const pathname = window.location.pathname;
    if (pathname !== (BASE_PREFIX !== '/' ? `${BASE_PREFIX}/login` : '/login')) {
      commonStore.getUserInfo();
    }
  }, []);

  useEffect(() => {
    document.title = commonStore.platformName || '智慧营销平台';
  }, [commonStore.platformName]);

  // 动态设置 favicon
  useEffect(() => {
    if (commonStore.loginLogoPath) {
      let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = commonStore.loginLogoPath;
    }
  }, [commonStore.loginLogoPath]);

  const context = useMemo(() => {
    return {
      permissionData: baseInfo?.permissionCodes,
      upload: {
        action: '/api/car/admin/activity/management/upload/image',
        headers: headers(),
        onUploadError: (file: any) => {
          const { error } = file;
          if (error?.status === 401) {
            Modal.destroyAll();
            toLoigin();
            message.error('登录失效，请重新登录');
          }
        },
      },
    };
  }, [baseInfo]);

  return (
    <Initialization>
      <Router basename={BASE_PREFIX}>
        <ConfigProvider>
          <UserInfoProvider value={context}>
            <RenderRouter routers={router} />
          </UserInfoProvider>
        </ConfigProvider>
      </Router>
    </Initialization>
  );
}

export default observer(App);
